import { render, staticRenderFns } from "./CreateCampaignSourceItem.vue?vue&type=template&id=5a37c1dc&scoped=true"
import script from "./CreateCampaignSourceItem.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceItem.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceItem.vue?vue&type=style&index=0&id=5a37c1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a37c1dc",
  null
  
)

export default component.exports